import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    trattamenti: [],
    singleTrattamenti: null,
    siccurezza: [],
    appicazione: [],
    trattamento: [],
    isLoading: false,
    error: null,
};
const trattamentiSlice = createSlice({
    name: "trattamenti",
    initialState,
    reducers: {
        setTrattamenti: (state, action) => {
            state.trattamenti = action.payload;
        },
        addTrattamenti: (state, action) => {
            state.trattamenti.push(action.payload);
        },
        addSiccurezza: (state, action) => {
            state.siccurezza = action.payload
        },
        addAppicazione: (state, action) => {
            state.appicazione = action.payload
        },
        addTrattamento: (state, action) => {
            state.trattamento = action.payload
        },
        setSingleTrattamenti: (state, action) => {
            // console.log("Updating Redux state with sensor data:", action.payload); // :white_check_mark: Check Redux update
            state.singleTrattamenti = action.payload;
        },
        updateTrattamenti: (state, action) => {
            const index = state.trattamenti.findIndex(
                (item) => item.id === action.payload.id
            );
            if (index !== -1) {
                state.trattamenti[index] = action.payload;
            }
        },
        deleteTrattamenti: (state, action) => {
            state.trattamenti = state.trattamenti.filter(
                (item) => item.id !== action.payload
            );
        },
        apiRequestStart: (state) => {
            state.isLoading = true;
            state.error = null;
        },
        apiRequestSuccess: (state) => {
            state.isLoading = false;
        },
        apiRequestFailure: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },
    },
});
export const {
    setTrattamenti,
    addTrattamenti,
    setSingleTrattamenti,
    updateTrattamenti,
    deleteTrattamenti,
    apiRequestStart,
    apiRequestSuccess,
    apiRequestFailure,
    getCultura,
    getVarieta,
    getCertificazioni,
    addSiccurezza,
    addAppicazione,
    addTrattamento
} = trattamentiSlice.actions;
export const selectTrattamenti = (state) => state.trattamenti?.trattamenti;
export const selectSingleTrattamenti = (state) => state.trattamenti?.singletrattamenti
export const selectIsLoading = (state) => state.trattamenti?.isLoading;
export const selectError = (state) => state.trattamenti?.error;
export default trattamentiSlice.reducer;